var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02884IconServiceWorkerContainerApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b27f1ad0-7d11-4247-9da3-91bce6211f32",
    x1: 8.798,
    y1: 8.703,
    x2: 14.683,
    y2: 8.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#773adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552f99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2f92112-4ca9-4b17-a019-c9f26c1a4a8f",
    x1: 5.764,
    y1: 3.777,
    x2: 5.764,
    y2: 13.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a67af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#773adc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b8a0486a-5501-4d92-b540-a766c4b3b548"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.932,11.578a8.448,8.448,0,0,1-7.95,5.59,8.15,8.15,0,0,1-2.33-.33,2.133,2.133,0,0,0,.18-.83c.01,0,.03.01.04.01a7.422,7.422,0,0,0,2.11.3,7.646,7.646,0,0,0,6.85-4.28l.01-.01Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.582,14.068a2.025,2.025,0,0,0-.64.56,8.6,8.6,0,0,1-1.67-2.44l1.04.23v.26a.6.6,0,0,0,.47.59l.14.03a6.136,6.136,0,0,0,.62.73Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.352.958a2.28,2.28,0,0,0-.27.81c-.02-.01-.05-.02-.07-.03a7.479,7.479,0,0,0-3.03-.63,7.643,7.643,0,0,0-5.9,2.8l-.29.06a.6.6,0,0,0-.48.58v.46l-1.02.19A8.454,8.454,0,0,1,8.982.268,8.6,8.6,0,0,1,12.352.958Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.872,5.7l-1.09-.38a6.6,6.6,0,0,0-.72-1.16c-.02-.03-.04-.05-.05-.07a2.083,2.083,0,0,0,.72-.45A7.81,7.81,0,0,1,16.872,5.7Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.072,11.908l2.54.56L8.672,14.1c-.02,0-.03.01-.05.01a.154.154,0,0,1-.15-.15V3.448a.154.154,0,0,1,.15-.15.09.09,0,0,1,.05.01l4.46,1.56-3.05.57a.565.565,0,0,0-.44.54v5.4A.537.537,0,0,0,10.072,11.908Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "e918f286-5032-4942-ad29-ea17e6f1cc90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1,5.668l1.21-.23v6.55l-1.23-.27-.99-.22a.111.111,0,0,1-.09-.12v-5.4a.12.12,0,0,1,.09-.12Z",
    fill: "#a67af4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a47a99dd-4d47-4c70-8c42-c5ac274ce496"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.072,11.908l2.54.56L8.672,14.1c-.02,0-.03.01-.05.01a.154.154,0,0,1-.15-.15V3.448a.154.154,0,0,1,.15-.15.09.09,0,0,1,.05.01l4.46,1.56-3.05.57a.565.565,0,0,0-.44.54v5.4A.537.537,0,0,0,10.072,11.908Z",
    fill: "url(#b27f1ad0-7d11-4247-9da3-91bce6211f32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.586,3.3,2.878,4.378a.177.177,0,0,0-.14.175V12.68a.177.177,0,0,0,.137.174L8.581,14.1a.176.176,0,0,0,.21-.174V3.478A.175.175,0,0,0,8.619,3.3Z",
    fill: "url(#b2f92112-4ca9-4b17-a019-c9f26c1a4a8f)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "5.948 4.921 5.948 12.483 7.934 12.814 7.934 4.564 5.948 4.921",
    fill: "#b796f9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3.509 5.329 3.509 11.954 5.238 12.317 5.238 5.031 3.509 5.329",
    fill: "#b796f9",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M16,2.048a1.755,1.755,0,1,1-1.76-1.76A1.756,1.756,0,0,1,16,2.048Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.65,
    cy: 15.973,
    r: 1.759,
    fill: "#32bedd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18,6.689v3.844a.222.222,0,0,1-.133.2l-.766.316-3.07,1.268-.011,0a.126.126,0,0,1-.038,0,.1.1,0,0,1-.1-.1V5.234a.1.1,0,0,1,.054-.088l0,0,.019,0a.031.031,0,0,1,.019,0,.055.055,0,0,1,.034.008l.011,0,.012,0L17.05,6.2l.8.282A.213.213,0,0,1,18,6.689Z",
    fill: "#773adc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.959,5.14l-3.8.715a.118.118,0,0,0-.093.117v5.409a.118.118,0,0,0,.091.116l3.8.831a.115.115,0,0,0,.137-.09.109.109,0,0,0,0-.026V5.256a.117.117,0,0,0-.115-.118A.082.082,0,0,0,13.959,5.14Z",
    fill: "#a67af4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02884IconServiceWorkerContainerApp);
export default __webpack_public_path__ + "static/media/02884-icon-service-Worker-Container-App.c7b025221d4a4dd929eeb1cadf4ddcd3.svg";
export { ForwardRef as ReactComponent };